import {
  Box,
  Button,
  ListItem,
  ListItemButton,
  ListItemButtonProps,
  ListItemIcon,
  ListItemText,
  SvgIcon,
  Typography,
  useTheme
} from '@mui/material';
import React, { ReactNode } from 'react';
import {
  useLocation,
  useNavigate
} from 'react-router-dom';


export type INavBarItem = {
  icon: ReactNode;
  path?: string ;
  label: string;
  isButton?: boolean;
  isSelected?: boolean;
};

export type NavBarItemProps = ListItemButtonProps & INavBarItem;

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: NavBarItemProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const selected = location.pathname === props.path ? true : false;



  return (
    <ListItem
      disableGutters
      disablePadding
      sx={{
        // borderRadius: '.25rem',
        borderRadius: '.75rem',
        backgroundColor: selected
          ? theme.palette.primary.contrastText
          : theme.palette.background.default,
        marginRight: '10px',
        alignContent: 'center'
      }}
    >
      {
        (props.isButton && props.label !== '')
          ? (
            <Button
              sx={{
                marginLeft: '1rem'
                // width: '14.5rem'
              }}
              fullWidth
              variant='text'
              color='primary'
              startIcon={props.icon}
            >
              {props.label}
            </Button>
          )
          : props.isButton
            ? (
              <Box
                marginLeft='1rem'
                display='flex'
                padding='.5rem'

                borderRadius='.75rem'
                bgcolor={selected ? theme.palette.primary.darker : theme.palette.primary.main}
              >
                {/* <CustomIcon.large.FC
                  icon='UPLOAD'
                  stroke={theme.palette.customGray.dark}
                /> */}

              </Box>
            )
            : (
              <>
                <ListItemButton
                  disableTouchRipple
                  disableRipple
                  disableGutters
                  sx={{
                    borderRadius: '.75rem',
                    backgroundColor: selected ? theme.palette.primary.contrastText : theme.palette.background.default,
                    paddingLeft: '15px'

                  }}
                  onClick={(ev) => {
                    if (props.onClick) {
                      ev.stopPropagation();
                      props.onClick(ev);
                    } else if (props.path) {
                      ev.stopPropagation();
                      navigate(props.path ?? '');
                    }
                  }}
                >
                  <ListItemIcon>
                    <Box
                      display='flex'
                      alignItems='center'
                      justifyItems='center'
                      padding='.5rem'
                      borderRadius='.75rem'
                    >
                      <SvgIcon>
                        {props.icon}
                      </SvgIcon>
                    </Box>
                  </ListItemIcon>

                  <ListItemText
                    disableTypography
                  >
                    <Typography
                      variant={selected ? 'selectedNavItemText' : 'navItemText'}
                      color={selected ? theme.palette.customGray.darker : theme.palette.customGray.dark}

                    >
                      {props.label}
                    </Typography>
                  </ListItemText>
                </ListItemButton>
              </>
            )
      }

    </ListItem>
  );
};
